"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpDefFeaturesRendererFactory = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const RosetteIcon_1 = __importDefault(require("@opsbase/web-icons/icons/RosetteIcon"));
const ScheduleClockIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ScheduleClockIcon"));
const ScheduleOnDemandIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ScheduleOnDemandIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Tooltip_1 = __importDefault(require("@opsbase/web-ui/Tooltip"));
const react_1 = __importDefault(require("react"));
const OpDefFeaturesRendererFactory = () => (item) => {
    if (!item)
        return null;
    const isScheduled = !!item.scheduled;
    const isOnDemand = !!item.permitAdhoc;
    const isScored = !!item.isScoreEnabled;
    return (react_1.default.createElement(Horizontal_1.default, { gutter: 2, justify: "flex-start" },
        isScheduled ? (react_1.default.createElement(Tooltip_1.default, { tip: lib_i18n_1.default.t('op_is_scheduled') },
            react_1.default.createElement(ScheduleClockIcon_1.default, null))) : (react_1.default.createElement(ScheduleClockIcon_1.default, { color: lib_palette_1.default.Grey })),
        isOnDemand ? (react_1.default.createElement(Tooltip_1.default, { tip: lib_i18n_1.default.t('op_is_ondemand') },
            react_1.default.createElement(ScheduleOnDemandIcon_1.default, null))) : (react_1.default.createElement(ScheduleOnDemandIcon_1.default, { color: lib_palette_1.default.Grey })),
        isScored ? (react_1.default.createElement(Tooltip_1.default, { tip: lib_i18n_1.default.t('op_is_scored') },
            react_1.default.createElement(RosetteIcon_1.default, null))) : (react_1.default.createElement(RosetteIcon_1.default, { color: lib_palette_1.default.Grey }))));
};
exports.OpDefFeaturesRendererFactory = OpDefFeaturesRendererFactory;
exports.default = exports.OpDefFeaturesRendererFactory;
